import Vue from 'vue'
import App from './App.vue'
import './cube-ui'
import router from './util/routes'
import preventReClick from './components/preventReClick' //防多次点击，重复提交
import * as filters from './util/filter'

Vue.config.productionTip = false

console.log('run with %s mode', process.env.ENV_MODE)

Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

var vue = new Vue({
  router,
  render: h => h(App),
  created: () => {}
}).$mount('#app')

export default vue